import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DashboardService } from '../.../../../services/dashboard.service';

@Component({
  selector: 'app-simreport',
  templateUrl: './simreport.component.html',
  styleUrls: ['./simreport.component.scss']
})
export class SimreportComponent implements OnInit {
  ngxLoader: any;
  dataSource: any;
  heading:any =[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(private DashboardService:DashboardService) { }

  ngOnInit() {
    this.fetchReportData();
  }
  fetchReportData() {
    this.dataSource = null;
    this.DashboardService.getSimReport().subscribe((response: any) => {
      this.heading =Object.keys(response.data[0]);
      this.dataSource = new MatTableDataSource(response.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

}
public doFilter = (value: string) => {
  this.dataSource.filter = value.trim().toLocaleLowerCase();
}
}
